"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AugLoopRuntimeManager = exports.IdentityProvider = void 0;
var runtime_client_1 = require("@augloop/runtime-client");
var schemas_1 = require("@augloop/schemas/dist/src/client/schemas");
Object.defineProperty(exports, "IdentityProvider", { enumerable: true, get: function () { return schemas_1.IdentityProvider; } });
var model_downloader_1 = require("@augloop/model-downloader");
// TODO: Add Logging Category (probably all the way down)
var index_1 = require("@ms/office-online-telemetry/lib/index");
/** @suppressusing */
var messages_g_1 = require("@augloop/excel-session-protocol/dist/src/generated/messages.g");
/** @suppressusing */
var messages_g_2 = require("@augloop/powerpoint-session-protocol/dist/src/generated/messages.g");
var getDataFieldType = function (obj) {
    var stringDataFieldType = 0;
    var booleanDataFieldType = 1;
    var int64DataFieldType = 2;
    if (typeof obj === 'string') {
        return stringDataFieldType;
    }
    else if (typeof obj === 'boolean') {
        return booleanDataFieldType;
    }
    else if (typeof obj === 'number') {
        // Only integers are supported for now
        return int64DataFieldType;
    }
    index_1.ULS.sendTraceTag(0x2224d18d /* tag_8jngn */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Warning, 'Unsupported data field type');
    return undefined;
};
var convertDataFields = function (data, prefix) {
    var systemMetadataDataClassification = 4;
    var dataFields = [];
    for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
        var key = _a[_i];
        if (data[key] === undefined || data[key] === null) {
            continue;
        }
        var dataField = {
            name: prefix ? prefix + "." + key : key,
            dataType: getDataFieldType(data[key]),
            value: data[key],
            // All of our client telemetry is (must be) SystemMetadata
            classification: systemMetadataDataClassification
        };
        dataFields.push(dataField);
    }
    return dataFields;
};
var convertTelemetryEvent = function (tenantToken, eventName, data, contract, contractData, dataCategories, diagnosticLevel) {
    var otelEvent = {
        telemetryProperties: { ariaTenantToken: tenantToken, nexusTenantToken: -1 },
        eventName: eventName.split('_').join('.'),
        dataFields: convertDataFields(data),
        eventFlags: {
            dataCategories: dataCategories,
            diagnosticLevel: diagnosticLevel
        }
    };
    if (contract) {
        otelEvent.eventContract = {
            name: contract,
            dataFields: convertDataFields(contractData, contract.split('.').slice(-1)[0])
        };
    }
    return otelEvent;
};
var executeLocalLambda = function (inputSchema, input, outputSchema, config) {
    // TODO: NYI
    if (inputSchema && input && outputSchema && config) {
        return Promise.resolve(null);
    }
    return Promise.resolve(null);
};
var areLicenseFeaturesEnabled = function (_licenseFeatures) {
    // TODO: NYI
    return Promise.resolve(false);
};
var AugLoopRuntimeManager = /** @class */ (function () {
    function AugLoopRuntimeManager() {
        var _this = this;
        this._telemetryAggregationIntervalSec = 30;
        this._eventHandlerDictionary = {};
        this.initialize = function (p) {
            if (_this._runtimeInitPromise) {
                index_1.ULS.sendTraceTag(0x2224d18e /* tag_8jngo */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Info, 'Runtime already initialized');
                return;
            }
            index_1.ULS.sendTraceTag(0x2224d18f /* tag_8jngp */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Info, 'Start and initialize augloop runtime ...');
            if (!p) {
                index_1.ULS.sendTraceTag(0x2224d190 /* tag_8jngq */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'initialize failed due to null parameters');
                return;
            }
            var serviceUrl = p.serviceUrl, appName = p.appName, appVersion = p.appVersion, uiLanguage = p.uiLanguage, releaseAudienceGroup = p.releaseAudienceGroup, releaseChannel = p.releaseChannel, releaseFork = p.releaseFork, sessionId = p.sessionId, initSession = p.initSession, flights = p.flights, privateMode = p.privateMode, disabledServiceGroups = p.disabledServiceGroups, sessionCreationOptions = p.sessionCreationOptions;
            _this.modelDownloaderFromCDN = (p.appName && p.downloadBaseUrl) ? new model_downloader_1.ModelDownloader(p.appName, p.downloadBaseUrl) : undefined;
            _this.excelServerParameters = p.excelServer;
            _this.powerpointParameters = p.powerpoint;
            // Initialize host metadata and host callbacks
            var hostMetadata = {
                appName: appName,
                appPlatform: 'Web',
                appVersion: appVersion,
                uiLanguage: uiLanguage,
                releaseAudienceGroup: releaseAudienceGroup,
                releaseChannel: releaseChannel,
                releaseFork: releaseFork,
                sessionId: sessionId,
                flights: flights,
                privateMode: privateMode,
                disabledServiceGroups: disabledServiceGroups
            };
            var hostCallbacks = {
                onResult: _this.onResult.bind(_this),
                onAnnotationResult: _this.onAnnotationResult.bind(_this),
                sendTelemetryEvent: _this.sendTelemetryEvent.bind(_this),
                requestAuthToken: _this.requestAuthToken.bind(_this),
                isFeatureEnabled: _this.isFeatureEnabled.bind(_this),
                executeLocalLambda: executeLocalLambda,
                setSessionData: _this.setSessionData.bind(_this),
                areLicenseFeaturesEnabled: areLicenseFeaturesEnabled,
                onInitSession: _this.onInitSession.bind(_this),
                overrideSessionInitMessage: _this.overrideSessionInitMessage.bind(_this)
            };
            var useSessionsPromise = _this.isFeatureEnabled('UseSessionsEbrake', 'None')
                .then(function (ebraked) {
                return !ebraked;
            });
            var runtimeInitPromise = useSessionsPromise
                .then(function (useSessions) {
                return runtime_client_1.runtime.init(serviceUrl, hostMetadata, hostCallbacks, {
                    telemetryAggregationIntervalSec: _this._telemetryAggregationIntervalSec,
                    initSession: useSessions ? undefined : !!initSession,
                    modelDownloader: _this.modelDownloaderFromCDN
                }).then(function () {
                    return useSessions;
                });
            });
            // Declare createSession and use it now to set _runtimeInitPromise synchronously so additional
            // calls to the AugLoopRuntimeManager are queued until _runtimeInitPromise resolves
            _this.createSession = function () {
                _this._runtimeInitPromise = runtimeInitPromise.then(function (useSessions) {
                    if (useSessions) {
                        return runtime_client_1.runtime.createSession(sessionCreationOptions);
                    }
                    return undefined;
                });
            };
            _this.createSession();
        };
        this.getSession = function () {
            return _this._runtimeInitPromise;
        };
        this.setULSLogger = function (p) {
            if (!p) {
                index_1.ULS.sendTraceTag(0x2224d191 /* tag_8jngr */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'setULSLogger failed due to null parameters');
                return;
            }
            var ulsLogger = p.ulsLogger;
            if (ulsLogger != null) {
                index_1.ULS.setLogger(ulsLogger);
            }
        };
        this.setSendOTelEventCallback = function (p) {
            if (!p) {
                index_1.ULS.sendTraceTag(0x2224d192 /* tag_8jngs */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'setSendOTelEventCallback failed due to null parameters');
                return;
            }
            var sendOTelEvent = p.sendOTelEvent;
            _this._sendOTelEventCallback = sendOTelEvent;
        };
        this.setRequestAuthTokenCallback = function (p) {
            if (!p) {
                index_1.ULS.sendTraceTag(0x2224d193 /* tag_8jngt */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'setRequestAuthTokenCallback failed due to null parameters');
                return;
            }
            var requestAuthTokenCallback = p.requestAuthTokenCallback;
            _this._requestAuthTokenCallback = requestAuthTokenCallback;
        };
        this.setIsFeatureEnabledCallback = function (p) {
            if (!p) {
                index_1.ULS.sendTraceTag(0x2224d194 /* tag_8jngu */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'setIsFeatureEnabledCallback failed due to null parameters');
                return;
            }
            var featureEnabledCallback = p.featureEnabledCallback;
            _this._featureEnabledCallback = featureEnabledCallback;
        };
        /************* START STATEFUL AUGMENTATION LOOP METHODS *************/
        this.registerLocalWorkflow = function (p) {
            if (!p) {
                index_1.ULS.sendTraceTag(0x2224d195 /* tag_8jngv */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'registerLocalWorkflow failed due to null parameters');
            }
            else if (!_this._runtimeInitPromise) {
                index_1.ULS.sendTraceTag(0x2224d196 /* tag_8jngw */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'registerLocalWorkflow called before initialize');
            }
            else if (!p.workflow) {
                index_1.ULS.sendTraceTag(0x2224d197 /* tag_8jngx */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'registerLocalWorkflow workflow was null');
            }
            else {
                _this._runtimeInitPromise.then(function (session) {
                    if (session) {
                        session.registerLocalWorkflow(p.workflow);
                    }
                    else {
                        runtime_client_1.runtime.registerLocalWorkflow(p.workflow);
                    }
                });
            }
        };
        this.activateAnnotation = function (p) {
            if (!p || !p.annotationType) {
                return Promise.reject(new Error('Invalid parameters'));
            }
            if (!_this._runtimeInitPromise) {
                return Promise.reject(new Error('Called before initialize'));
            }
            return _this._runtimeInitPromise.then(function (session) {
                var options;
                if (p.handler || p.stateUpdateHandler) {
                    options = { callback: p.handler, stateUpdateCallback: p.stateUpdateHandler };
                }
                if (session) {
                    return session.activateAnnotation(p.annotationType, options);
                }
                return runtime_client_1.runtime.activateAnnotation(p.annotationType, options);
            });
        };
        this.releaseAnnotation = function (p) {
            if (!p || !p.token) {
                return Promise.reject(new Error('Invalid parameters'));
            }
            if (!_this._runtimeInitPromise) {
                return Promise.reject(new Error('Called before initialize'));
            }
            return _this._runtimeInitPromise.then(function (session) {
                if (session) {
                    return session.releaseAnnotation(p.token);
                }
                return runtime_client_1.runtime.releaseAnnotation(p.token);
            });
        };
        this.submitOperation = function (p) {
            if (!p) {
                index_1.ULS.sendTraceTag(0x2224d198 /* tag_8jngy */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'submitOperation failed due to null parameters');
                return;
            }
            var operation = p.operation;
            if (!operation) {
                index_1.ULS.sendTraceTag(0x2224d199 /* tag_8jngz */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'Operation was null');
            }
            else if (!_this._runtimeInitPromise) {
                index_1.ULS.sendTraceTag(0x2224d19a /* tag_8jng0 */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'submitOperation called before initialize');
            }
            else {
                _this._runtimeInitPromise.then(function (session) {
                    if (session) {
                        session.submitOperation(operation);
                        return;
                    }
                    runtime_client_1.runtime.submitOperation(operation);
                });
            }
        };
        this.setSessionDataCallback = function (p) {
            if (!p) {
                index_1.ULS.sendTraceTag(0x2224d19b /* tag_8jng1 */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'setSessionDataCallback failed due to null parameters');
                return;
            }
            var handler = p.handler, sessionDataCallback = p.sessionDataCallback;
            if (sessionDataCallback) {
                _this._setSessionDataCallback = sessionDataCallback;
            }
            else if (handler) {
                _this._setSessionDataCallback = function (sessionUrl, origin, _authToken) { return handler(sessionUrl, origin); };
            }
        };
        this.setAnnotationResultCallback = function (p) {
            if (!p) {
                index_1.ULS.sendTraceTag(0x2224d19c /* tag_8jng2 */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'setAnnotationResultCallback failed due to null parameters');
                return;
            }
            var handler = p.handler;
            _this._annotationResultCallback = handler;
        };
        this.setAnnotationState = function (p) {
            if (!p) {
                index_1.ULS.sendTraceTag(0x2224d19d /* tag_8jng3 */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'setAnnotationState failed due to null parameters');
            }
            else {
                _this._runtimeInitPromise.then(function (session) {
                    if (session) {
                        session.setAnnotationState(p.parentPath, p.id, p.value);
                        return;
                    }
                    runtime_client_1.runtime.setAnnotationState(p.parentPath, p.id, p.value);
                });
            }
        };
        this.setInitSessionCallback = function (p) {
            if (!p) {
                index_1.ULS.sendTraceTag(0x2224d19e /* tag_8jng4 */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'setInitSessionCallback failed due to null parameters');
            }
            else {
                var initSessionCallback = p.initSessionCallback;
                _this._initSessionCallback = initSessionCallback;
            }
        };
        this.setSessionInitOverrideCallback = function (p) {
            if (!p) {
                index_1.ULS.sendTraceTag(0x2224d19f /* tag_8jng5 */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'setSessionInitOverrideCallback failed due to null parameters');
            }
            else {
                var handler = p.handler;
                _this._sessionInitOverrideCallback = handler;
            }
        };
        this.forceReconnectSession = function (p) {
            return _this._runtimeInitPromise.then(function (session) {
                if (p.excelServerParameters) {
                    _this.excelServerParameters = p.excelServerParameters;
                }
                if (session) {
                    return session.forceReconnect();
                }
                return runtime_client_1.runtime.forceReconnectSession();
            });
        };
        this.setSessionCloseCallback = function (p) {
            if (!p) {
                return Promise.reject(new Error('setSessionCloseCallback failed due to null parameters'));
            }
            var callback = p.callback;
            if (!callback) {
                return Promise.reject(new Error('setSessionCloseCallback callback was null'));
            }
            return _this._runtimeInitPromise.then(function (session) {
                if (session) {
                    session.setSessionCloseCallback(callback);
                    return;
                }
                runtime_client_1.runtime.setSessionCloseCallback(callback);
            });
        };
        this.submitCustomMessage = function (p) {
            if (!p) {
                var errorMessage = 'submitCustomMessage failed due to null parameters';
                index_1.ULS.sendTraceTag(0x2224d1a0 /* tag_8jng6 */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, errorMessage);
                return Promise.reject(new Error(errorMessage));
            }
            var message = p.message;
            if (!message) {
                var errorMessage = 'Message was null';
                index_1.ULS.sendTraceTag(0x2224d1a1 /* tag_8jng7 */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, errorMessage);
                return Promise.reject(new Error(errorMessage));
            }
            else if (!_this._runtimeInitPromise) {
                var errorMessage = 'submitCustomMessage called before initialize';
                index_1.ULS.sendTraceTag(0x2224d1a2 /* tag_8jng8 */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, errorMessage);
                return Promise.reject(new Error(errorMessage));
            }
            else {
                return _this._runtimeInitPromise.then(function (session) {
                    if (session) {
                        return session.submitCustomMessage(message);
                    }
                    return runtime_client_1.runtime.submitCustomMessage(message);
                });
            }
        };
        this.closeSession = function () {
            if (!_this._runtimeInitPromise) {
                var errorMessage = 'closeSession called before initialize';
                index_1.ULS.sendTraceTag(0x2224d1a3 /* tag_8jng9 */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, errorMessage);
                return Promise.reject(new Error(errorMessage));
            }
            else {
                return _this._runtimeInitPromise.then(function (session) {
                    if (session) {
                        session.close();
                        return;
                    }
                    runtime_client_1.runtime.closeSession();
                });
            }
        };
        this.startNewSession = function () {
            if (!_this.createSession) {
                index_1.ULS.sendTraceTag(0x2224d1c0 /* tag_8jnha */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'startNewSession called before initialize');
                return;
            }
            _this.createSession();
        };
        /************* END OF STATEFUL AUGMENTATION LOOP METHODS *************/
        /************* START STATELESS AUGMENTATION LOOP METHODS *************/
        this.submit = function (p) {
            if (!p) {
                index_1.ULS.sendTraceTag(0x2224d1c1 /* tag_8jnhb */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'submit failed due to null parameters');
                return;
            }
            var inputSchema = p.inputSchema, input = p.input, correlationVector = p.correlationVector;
            if (!_this._runtimeInitPromise) {
                index_1.ULS.sendTraceTag(0x2224d1c2 /* tag_8jnhc */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'onSubmit called before initialize');
            }
            else if (!inputSchema || !input) {
                index_1.ULS.sendTraceTag(0x2224d1c3 /* tag_8jnhd */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, "Null parameter. inputSchema:" + inputSchema + " correlationVector:" + correlationVector + " input:" + input);
            }
            else {
                _this._runtimeInitPromise.then(function () {
                    runtime_client_1.runtime.submit(inputSchema, input, correlationVector);
                });
            }
        };
        this.addEventHandler = function (p) {
            if (!p) {
                index_1.ULS.sendTraceTag(0x2224d1c4 /* tag_8jnhe */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'addEventHandler failed due to null parameters');
                return;
            }
            var schemaName = p.schemaName, handler = p.handler;
            if (!schemaName) {
                return;
            }
            var eventHandlers = _this._eventHandlerDictionary[schemaName] || [];
            eventHandlers.push(handler);
            _this._eventHandlerDictionary[schemaName] = eventHandlers;
        };
        this.removeEventHandler = function (p) {
            if (!p) {
                index_1.ULS.sendTraceTag(0x2224d1c5 /* tag_8jnhf */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'removeEventHandler failed due to null parameters');
                return;
            }
            var schemaName = p.schemaName, handler = p.handler;
            if (!schemaName || !handler) {
                return;
            }
            var handlers = _this._eventHandlerDictionary[schemaName];
            if (!Array.isArray(handlers)) {
                return;
            }
            var index = handlers.indexOf(handler);
            if (index >= 0) {
                handlers.splice(index, 1);
            }
        };
        this.registerSimpleRemoteWorkflow = function (p) {
            if (!p) {
                index_1.ULS.sendTraceTag(0x2224d1c6 /* tag_8jnhg */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'registerSimpleRemoteWorkflow failed due to null parameters');
                return Promise.resolve();
            }
            var name = p.name, lambdaBefore = p.lambdaBefore, lambdaRemote = p.lambdaRemote, lambdaAfter = p.lambdaAfter;
            if (!_this._runtimeInitPromise) {
                index_1.ULS.sendTraceTag(0x2224d1c7 /* tag_8jnhh */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'registerSimpleRemoteWorkflow called before initialize');
            }
            else if (!name || !lambdaRemote) {
                index_1.ULS.sendTraceTag(0x2224d1c8 /* tag_8jnhi */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, "Null parameters. name:" + name + " lambdaRemote:" + lambdaRemote);
            }
            else {
                return _this._runtimeInitPromise.then(function () {
                    return runtime_client_1.runtime.registerSimpleRemoteWorkflow(name, lambdaBefore, lambdaRemote, lambdaAfter);
                });
            }
            // Should only be hit in the error case
            return Promise.resolve();
        };
        this.registerSimpleLocalWorkflow = function (p) {
            if (!p) {
                index_1.ULS.sendTraceTag(0x2224d1c9 /* tag_8jnhj */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'registerSimpleLocalWorkflow failed due to null parameters');
                return Promise.resolve();
            }
            var name = p.name, lambda = p.lambda;
            if (!_this._runtimeInitPromise) {
                index_1.ULS.sendTraceTag(0x2224d1ca /* tag_8jnhk */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'registerSimpleLocalWorkflow called before initialize');
            }
            else if (!name || !lambda) {
                index_1.ULS.sendTraceTag(0x2224d1cb /* tag_8jnhl */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, "Null parameters. name:" + name + " lambda:" + lambda);
            }
            else {
                return _this._runtimeInitPromise.then(function () {
                    return runtime_client_1.runtime.registerSimpleLocalWorkflow(name, lambda);
                });
            }
            // Should only be hit in the error case
            return Promise.resolve();
        };
        this.registerReduceWorkflow = function (p) {
            if (!p) {
                index_1.ULS.sendTraceTag(0x2224d1cc /* tag_8jnhm */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'registerReduceWorkflow failed due to null parameters');
                return Promise.resolve();
            }
            var name = p.name, lambda = p.lambda, groupingKeyExtractor = p.groupingKeyExtractor;
            if (!_this._runtimeInitPromise) {
                index_1.ULS.sendTraceTag(0x2224d1cd /* tag_8jnhn */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'registerReduceWorkflow called before initialize');
            }
            else if (!name || !lambda || !groupingKeyExtractor) {
                index_1.ULS.sendTraceTag(0x2224d1ce /* tag_8jnho */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, "Null parameters. name:" + name + " lambda:" + lambda + " groupingKeyExtractor:" + groupingKeyExtractor);
            }
            else {
                return _this._runtimeInitPromise.then(function () {
                    return runtime_client_1.runtime.registerReduceWorkflow(name, lambda, groupingKeyExtractor);
                });
            }
            // Should only be hit in the error case
            return Promise.resolve();
        };
        /************* END OF STATELESS AUGMENTATION LOOP METHODS *************/
        /************* START DEPRECATED AUGMENTATION LOOP METHODS *************/
        this.registerSchemas = function (p) {
            if (!p) {
                index_1.ULS.sendTraceTag(0x2224d1cf /* tag_8jnhp */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'registerSchemas failed due to null parameters');
                return Promise.resolve();
            }
            var proto = p.proto, schemaNames = p.schemaNames;
            if (!_this._runtimeInitPromise) {
                index_1.ULS.sendTraceTag(0x2224d1d0 /* tag_8jnhq */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, 'registerSchemas called before initialize');
            }
            else if (!proto || !schemaNames) {
                index_1.ULS.sendTraceTag(0x2224d1d1 /* tag_8jnhr */, index_1.LogCategory.msoulscat_Wac_BrowserGeneral, index_1.TraceLevel.Error, "Null parameters. proto:" + proto + " schemaNames:" + schemaNames);
            }
            else {
                return _this._runtimeInitPromise.then(function () {
                    var schemas = schemaNames.filter(function (schemaName) { return !!schemaName; });
                    return runtime_client_1.runtime.registerSchemas(proto, schemas);
                });
            }
            // Should only be hit in the error case
            return Promise.resolve();
        };
        /************* END OF DEPRECATED AUGMENTATION LOOP METHODS *************/
        this.onResult = function (inputSchema, input, outputSchema, output) {
            var eventHandlers = _this._eventHandlerDictionary[outputSchema];
            if (!eventHandlers) {
                return;
            }
            for (var _i = 0, eventHandlers_1 = eventHandlers; _i < eventHandlers_1.length; _i++) {
                var handler = eventHandlers_1[_i];
                if (handler != null) {
                    var result = {
                        inputSchema: inputSchema,
                        input: input,
                        outputSchema: outputSchema,
                        output: output
                    };
                    handler(result);
                }
            }
        };
        this.onAnnotationResult = function (operation) {
            if (_this._annotationResultCallback) {
                _this._annotationResultCallback(operation);
            }
        };
        this.requestAuthToken = function (tokenRequest) {
            if (!_this._requestAuthTokenCallback) {
                return Promise.resolve({ Token: '' });
            }
            var tokenCallback = _this._requestAuthTokenCallback(tokenRequest) || Promise.resolve('');
            return tokenCallback.then(function (tokenValue) {
                var token = tokenValue || '';
                return Promise.resolve({ Token: token });
            });
        };
        this.sendTelemetryEvent = function (tenant, eventName, data, contract, contractData, _critical, dataCategories, diagnosticLevel) {
            if (_this._sendOTelEventCallback) {
                _this._sendOTelEventCallback(convertTelemetryEvent(tenant, eventName, data, contract, contractData, dataCategories, diagnosticLevel));
            }
        };
        this.isFeatureEnabled = function (feature, _scope) {
            if (!feature) {
                return Promise.resolve(false);
            }
            var preName = 'Microsoft.Office.AugLoop.';
            if (feature.indexOf(preName) === 0 && _this._featureEnabledCallback) {
                var featureName = feature.slice(preName.length);
                return Promise.resolve(_this._featureEnabledCallback(featureName));
            }
            return Promise.resolve(false);
        };
        this.setSessionData = function (sessionUrl, origin, authToken) {
            if (_this._setSessionDataCallback) {
                _this._setSessionDataCallback(sessionUrl, origin, authToken);
            }
        };
        this.overrideSessionInitMessage = function (sessionInitMessage) {
            if (_this._sessionInitOverrideCallback) {
                return _this._sessionInitOverrideCallback(sessionInitMessage);
            }
            if (sessionInitMessage.clientMetadata.appName.indexOf('Excel') === 0) {
                if (_this.excelServerParameters) {
                    return _this.overrideExcelSessionInitMessage(sessionInitMessage);
                }
            }
            if (sessionInitMessage.clientMetadata.appName.indexOf('PowerPoint') === 0) {
                if (_this.powerpointParameters) {
                    return _this.overridePowerPointSessionInitMessage(sessionInitMessage);
                }
            }
            return sessionInitMessage;
        };
        this.overrideExcelSessionInitMessage = function (sessionInitMessage) {
            var initMessage = {
                cluster: _this.excelServerParameters.wacCluster,
                restUrl: _this.excelServerParameters.ecsRestUrl,
                ecsId: _this.excelServerParameters.ecsSessionId,
                ecsOperationUrl: _this.excelServerParameters.ecsOperationUrl,
                workbookMetadataVersion: _this.excelServerParameters.metadataVersion,
                serverEventVersion: _this.excelServerParameters.serverEventVersion,
                permissionFlags: _this.excelServerParameters.permissionFlags,
                configurations: _this.excelServerParameters.configurations,
                collabUserListVersion: _this.excelServerParameters.userListVersion,
                collabStateId: _this.excelServerParameters.collabStateId,
                accessToken: _this.excelServerParameters.accessToken,
                accessTokenTTL: _this.excelServerParameters.accessTokenTTL,
                supportCustomMessages: _this.excelServerParameters.supportCustomMessages
            };
            for (var _i = 0, _a = Object.keys(sessionInitMessage); _i < _a.length; _i++) {
                var key = _a[_i];
                initMessage[key] = sessionInitMessage[key];
            }
            return new messages_g_1.ExcelServerSessionInitMessage(initMessage);
        };
        this.overridePowerPointSessionInitMessage = function (sessionInitMessage) {
            var initMessage = {
                downloadUrl: _this.powerpointParameters.downloadUrl,
                getItemsEndPoint: _this.powerpointParameters.getItemsEndPoint,
                documentOpenType: _this.powerpointParameters.documentOpenType
            };
            for (var _i = 0, _a = Object.keys(sessionInitMessage); _i < _a.length; _i++) {
                var key = _a[_i];
                initMessage[key] = sessionInitMessage[key];
            }
            return new messages_g_2.PowerPointSessionInitMessage(initMessage);
        };
        this.onInitSession = function () {
            if (!_this._initSessionCallback) {
                return Promise.resolve();
            }
            return _this._initSessionCallback();
        };
    }
    return AugLoopRuntimeManager;
}());
exports.AugLoopRuntimeManager = AugLoopRuntimeManager;
//# sourceMappingURL=AugLoopRuntimeManager.js.map